import type { CanDeactivateFn } from "@angular/router";
import type { ILeaveConfirmable } from "./i-leave-confirmable";

/**
 * Asks before leaving a page with unsaved work — Cancel, the back button, a
 * nav link. The page decides whether there is anything to lose; this only
 * gives it the chance. Closing the tab is handled by the page itself, since
 * the router never sees it.
 */
export const unsavedChangesGuard: CanDeactivateFn<ILeaveConfirmable> = (
  page: ILeaveConfirmable
): boolean => page.canLeave();
